import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-arm-details-form',
  templateUrl: './new-arm-details-form.component.html',
  styleUrls: ['./new-arm-details-form.component.css']
})
export class NewArmDetailsFormComponent implements OnInit {
  title="Add Arms Detail";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/arm-details/new-arm-details-form/new-arm-details-form.component.ts